<template>
  <div class="pendencies-data-table">
    <reply-pendency-modal
      ref="resolvePendency"
      :pendency="currentPendencyOpen"
      @updated="refreshPendencies()"
      @closed="clearPendencyClosed()"
    />

    <data-table
      :header="table.header"
      @sort="handleSort"
    >
      <pendency-row
        :pendencies="pendenciesPending"
        :status="status"
        @openModal="openModal"
        @openPendencyImages="openPendencyImages"
      />
      <pendency-row
        :pendencies="pendenciesResolved"
        :status="status"
        @openModal="openModal"
        @openPendencyImages="openPendencyImages"
      />
    </data-table>

    <infinite-loading
      :key="keyInfiniteLoading"
      slot="append"
      ref="infiniteLoading"
      :identifier="pendenciesForceUpdatedInfiniteLoading"
      :force-use-infinite-wrapper="true"
      @infinite="onInfinite"
    >
      <span slot="no-more" />
      <span slot="no-results" />
      <span
        slot="spinner"
        class="spinner"
        :class="{ 'spinner--small': pendencies.length > 0 }"
      >
        <spinner />
      </span>
    </infinite-loading>

    <div
      v-if="pendenciesLoadingStatus === 'STATUS_END' && pendencies.length === 0"
      class="empty-search"
    >
      <svg-loader src="/static/images/icon-no-tubes-found.svg" />
      <p>Não encontramos nenhum resultado para sua busca.</p>
    </div>

    <div
      v-if="pendenciesLoadingStatus === 'STATUS_FAILED' && pendencies.length === 0"
      class="empty-search"
    >
      <svg-loader src="/static/images/icon-no-tubes-found.svg" />
      <p>Não foi possível buscar pendências. Tente novamente.</p>
    </div>

    <PendenciesImagesModal ref="pendencyImagesModal" />
  </div>
</template>

<script>
import DataTable from '../common/dataTable/DataTableV2'
import DataCell from '../common/dataTable/DataCell'
import Spinner from '../common/Spinner'
import PendenciesImagesModal from '@/components/Pendencies/PendenciesImagesModal'
import PendencyRow from './PendencyRow'

import { mapGetters, mapActions } from 'vuex'

import strings from '@/strings'
import InfiniteLoading from 'vue-infinite-loading'
import ReplyPendencyModal from '../Pendencies/ReplyPendencyModal'
import { startCase } from 'lodash'
import { PENDENCIES_ORDER_BY_PATIENT_NAME, PENDENCIES_ORDER_BY_STATUS, PENDENCIES_ORDER_BY_SEND_DATE } from '@/enums'

export default {
  name: 'PendenciesDataTable',
  components: {
    'data-table': DataTable,
    'data-cell': DataCell,
    'reply-pendency-modal': ReplyPendencyModal,
    'infinite-loading': InfiniteLoading,
    spinner: Spinner,
    PendenciesImagesModal,
    PendencyRow
  },
  data() {
    return {
      status: strings.pendenciesStatus,
      currentPendencyOpen: {},
      table: {
        header: [
          {
            title: 'Data',
            subtitle: 'hora',
            value: PENDENCIES_ORDER_BY_SEND_DATE,
            sort: false,
            size: 10
          },
          {
            title: 'Os Àlvaro',
            value: 'orderId',
            sort: false,
            size: 10
          },
          {
            title: 'Nome',
            value: PENDENCIES_ORDER_BY_PATIENT_NAME,
            sort: false,
            size: 15
          },
          {
            title: 'Exames',
            value: 'exames',
            sort: false,
            size: 10
          },
          {
            title: 'Motivo',
            value: 'reason',
            sort: false,
            size: 15
          },
          {
            title: 'Prazo de resposta',
            subtitle: 'Data da Pendência',
            size: 15,
            sort: true
          },
          {
            title: 'Status',
            value: PENDENCIES_ORDER_BY_STATUS,
            sort: true,
            size: 15
          },
          {
            title: 'Ação',
            value: 'action',
            sort: false,
            size: 10
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'pendencies',
      'pendenciesLoadingStatus',
      'pendenciesParams',
      'totalPendenciesQuantity',
      'pendenciesForceUpdatedInfiniteLoading'
    ]),
    pendenciesPending() {
      return this.pendencies.filter(p => p.status === 'P');
    },
    pendenciesResolved() {
      return this.pendencies.filter(p => p.status === 'R' || p.status === 'T');
    },
    keyInfiniteLoading() {
      return this.pendenciesForceUpdatedInfiniteLoading?.toString();
    }
  },
  watch: {
    pendenciesLoadingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_END':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_SUCCESS':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          this.setWaitingPendenciesLoadingStatus()
          break
        case 'STATUS_FAILED':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_INITIAL':
          this.clearAllPendenciesData()
          this.getTotalPendenciesQuantity()
          if (this.$refs.infiniteLoading) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
          }
          break
        case 'STATUS_WAITING':
          break
        default:
          break
      }
    }
  },
  methods: {
    ...mapActions([
      'getPendencies',
      'getTotalPendenciesQuantity',
      'clearAllPendenciesData',
      'setWaitingPendenciesLoadingStatus',
      'selectPendenciesFilter',
      'fetchPendenciesForTable',
    ]),
    async onInfinite($state) {
      try {
        await this.fetchPendenciesForTable();
        if (this.pendencies.length === 0 || this.pendenciesParams.offset >= this.totalPendenciesQuantity) {
          $state.complete();
        } else {
          $state.loaded();
        }
      } catch (error) {
        $state.complete();
      }
    },
    openModal(pendency) {
      this.currentPendencyOpen = pendency
      this.$nextTick(function () {
        this.$refs.resolvePendency.openModal()
      })
      this.submitAnalyticsEvent('Abrir modal de responder pendencia')
    },
    clearPendencyClosed() {
      this.currentPendencyOpen = {}
    },
    refreshPendencies() {
      this.clearAllPendenciesData()
    },
    submitAnalyticsEvent(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Gestao de Pendencias',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    openPendencyImages(pendency) {
      this.$refs.pendencyImagesModal.openModal(pendency)
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString('pt-BR') : ''
    },
    formatHour(date) {
      return date ? new Date(date).toLocaleTimeString('pt-BR') : ''
    },
    capitalize(value) {
      return startCase(value.toLowerCase())
    },
    uppercase(value) {
      if (value != null) {
        return value.toUpperCase()
      }
      return '-'
    },
    handleSort(sortState) {
      this.selectPendenciesFilter({
        ...this.pendenciesParams,
        orderBy: sortState.value,
        offset: 0
      });
      this.clearAllPendenciesData();
      this.getPendencies();
    }
  }
}
</script>

<style lang="scss">
.pendencies-data-table {
  .status {
    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 26px;
      text-transform: uppercase;
    }

    &-orange {
      p {
        color: #f5a623;
      }
    }

    &-green {
      p {
        color: #55cd9e;
      }
    }

    &-red {
      p {
        color: red;
      }
    }
  }

  .action {
    &-canceled {
      cursor: not-allowed;

      button {
        pointer-events: none;
      }
    }
  }

  .overflow {
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .capitalize {
    text-transform: capitalize;
  }

  button {
    justify-content: center;
    display: flex;
    flex-wrap: nowrap;
    max-width: 207px;

    .icon {
      flex: 1;
      margin-left: 0.1em;
    }

    span {
      flex: 3;
      font-weight: 500;
      font-size: 12px;
      letter-spacing: 0.8px;
    }
  }

  .data-table__body__row {
    border-radius: 3px;
    background: #fff;
    margin-bottom: 1em;
    display: flex;
    height: 80px;
  }

  .data-table__body__row__cell button {
    width: calc(100% - 28px);
    padding: 0;
    margin-right: 10px;
    display: flex;
  }

  .empty-exam {
    color: black;
    text-align: start;
    font-style: inherit;
    font-weight: 700;
  }

  .empty-search {
    width: 25%;
    position: relative;
    margin: 6% auto auto;

    .md-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 1em;
      margin-left: 40%;
    }

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #7a7a7a;
    }
  }

  .action-pending,
  .action-replied {
    display: flex;
  }
}
</style>
